import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import { WorksheetRootComponent } from 'Components/Worksheets/Core';
import ids from 'Components/Worksheets/QestIds';
import { parse, toString } from 'Lib/Object/Path/shared';
import { dropLast } from 'ramda';
import { MeasurementsSection, PreparationSection, ResultsSection } from '../../Shared';

let BsEmbeddedMoistureConditionValueWorksheet: WorksheetRootComponent = ({ namePrefix }) => {
  return (
    <>
      <PageSection heading="Preparation">
        <PreparationSection hideNoneEmbeddedTestFields />
      </PageSection>

      <PageSection heading="Moisture Condition Value Measurements">
        <MeasurementsSection />
      </PageSection>

      <PageSection heading="Results">
        <ResultsSection chartNamePrefix={`${toString(dropLast(1, parse(namePrefix!)))}.McvChart`} />
      </PageSection>
    </>
  );
};

BsEmbeddedMoistureConditionValueWorksheet.qestIds = [ids.moistureConditionValue.BS_1377_2_Clause_13_4.rev2022];
BsEmbeddedMoistureConditionValueWorksheet = withInjectedProps(BsEmbeddedMoistureConditionValueWorksheet);

export { BsEmbeddedMoistureConditionValueWorksheet };
export default BsEmbeddedMoistureConditionValueWorksheet;
